/* eslint-disable react-hooks/exhaustive-deps */
import {
  auditComments,
  getTaskUpdateRecords,
  getworkWpsPreViewCode,
  queryTaskProcessAuditList
} from "@/api/work";
import "./Advance.less";
import { Button, Empty, Input, message, Modal, Radio } from "antd";
import Steps from "antd/lib/steps";
import { Loading } from "@jd/focus-desktop-comps";
import { connect } from "dva";
import React, { useCallback, useEffect, useRef, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import UniqBy from "lodash/uniqBy";
import { isFocusEnv, FocusSDK, DownloadItem } from "@/utils";
import { FileStatus } from "@/components/Calendars/Attachment";
import { mattchUrl, getFileIconByMime, getFileUrl, downLoadFile } from "@/utils/chat/index";
import { changeEgovUrl, htmlUnescape } from "@/utils/tools";
import { productBriefTimeStr } from "../../utils";
import {
  buildPagePathKey,
  buildJoyspaceIconUrl
} from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { CalendarIcon } from "@/components/Calendars/Common";
import IconFont from "@/components/icon";
import {
  ACTION_TYPE,
  AdvanceRecordModel,
  PriorityList,
  PROCESS_STATUS,
  RecordsParams,
  taskProcessAuditList,
  WorkUserInfo
} from "@/types/newWork";
import ScrollView from "@/baseComponents/ScrollView";
import { number2percentum } from "../../BaseComponents/WorkUserListWeightSet";
import GlobalContext from "@/context/GlobalContext";
import { analysisLog } from "@/utils/logAnalytics";
import AttachmentComp from "@/components/AttachmentComp/handleAttachment";
import { PROCESS_STATUS_EXECUTORS } from "@/components/Projects/emnu";
import { canJoyspacePreview, openJoyspacePreview } from "@/components/Joyspace/util";
import { getDownloadFileRes } from "@/components/chat/utils/commonMessageModal";
import { ErrorCode } from "@/components/Joyspace/components/BatchDownloadPanel/type";
import { UserModel } from "@/models/user";
import { BusinessForm } from "@/utils/chat/message";

const { Step } = Steps;

function AdvanceCom({
  taskId,
  advanceUser,
  pullRecords,
  className,
  files,
  handleReject,
  owner,
  userData,
  isQueryAuditList = false
}: {
  taskId: string;
  advanceUser: WorkUserInfo;
  pullRecords?: boolean | number;
  className?: string;
  files?: [];
  handleReject: Function;
  owner?: WorkUserInfo;
  userData: UserModel;
  isQueryAuditList?: boolean;
}) {
  const { t } = useTranslation("work");
  const { appRuntimeEnv, focusSDK } = useContext(GlobalContext);
  const { fileService, gateway, joyspaceApiHost, joyspaceHost } = appRuntimeEnv;
  const [RecordsData, setRecordsData] = useState<AdvanceRecordModel[]>([]);
  const [ProcessAuditList, setProcessAuditList] = useState<taskProcessAuditList[]>([]);
  const [AuditItem, setAuditItem] = useState<taskProcessAuditList>();
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(1); // 页码(1页/20条)
  const [gotRecordsInitially, setGotRecordsInitially] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [RejectValue, setRejectValue] = useState("");
  const scrollRef = useRef(null);

  /**
   * 初始化数据
   */
  useEffect(() => {
    if (!taskId) {
      return;
    }
    getRecords();
    // return () => {
    //     setRecordsData([]);
    // };
  }, [count]);
  useEffect(() => {
    if (!taskId) {
      return;
    }
    if (gotRecordsInitially && pullRecords) {
      setCount(1);
      getRecords();
    }
  }, [pullRecords]);

  const OnauditComments = (params: any) => {
    auditComments(params).then(([res, err]: any) => {
      if (params.auditStatus !== 1) {
        setRejectValue("");
        setIsModalOpen(false);
      }
      if (err) {
        return message.error(err);
      }
      // 驳回后走一遍接口刷新
      getRecords();
      handleReject();
    });
  };

  // 驳回
  const onReject = useCallback(() => {
    let params = {
      auditId: AuditItem?.auditId,
      taskId: AuditItem?.taskId,
      auditStatus: 2,
      auditComments: RejectValue
    };
    OnauditComments(params);
  }, [RejectValue]);

  // hanleOk 同意
  const hanleOk = (item: taskProcessAuditList) => {
    // 直接走接口 auditStatus: 1同意  2驳回
    let params = {
      auditId: item.auditId,
      taskId: item.taskId,
      auditStatus: 1
    };
    OnauditComments(params);
  };

  const RejectChange = (e: any) => {
    setRejectValue(e.target.value.trim());
  };

  function getRecords() {
    let params: RecordsParams = { taskId: taskId, offset: (count - 1) * 20, limit: 20 };
    if (advanceUser) {
      params = {
        taskId: taskId,
        offset: (count - 1) * 20,
        limit: 20,
        userId: advanceUser?.userId || "",
        teamId: advanceUser?.teamId || "",
        appId: advanceUser?.app || ""
      };
    }
    setLoading(true);
    getTaskUpdateRecords(params).then(([result, err]: any) => {
      setLoading(false);
      if (err) {
        message.error(err as string);
        return;
      }
      if (!result && !result.records.length) {
        return;
      }
      setTotal(result?.total);
      let _RecordsData = RecordsData;
      if (count === 1) {
        _RecordsData = [];
      }
      let data = [];
      if (result?.records.length) {
        data = [..._RecordsData, ...result.records].sort(function (a: any, b: any) {
          return b.time - a.time;
        });
      }
      // const data = [..._RecordsData, ...result?.records].sort(function (a: any, b: any) {
      //   return b.time - a.time;
      // });
      setRecordsData(data);
      setGotRecordsInitially(true);
    });
    // 协同人或负责人可查审核纪录
    if (isQueryAuditList) {
      queryTaskProcessAuditList({ taskId: taskId }).then(([res, err]: any) => {
        setLoading(false);
        if (err) {
          message.error(err as string);
          return;
        }
        if (!res) {
          setProcessAuditList([]);
          return;
        }
        setProcessAuditList(res.taskProcessAuditList);
      });
    } else {
      setLoading(false);
    }
  }
  const changePriorityType = useCallback(
    (priority: string) => {
      const priorityItem = PriorityList.find((p) => p.code.toString() === priority) || ({} as any);
      return priority ? (
        <img className="priority-img" src={changeEgovUrl(priorityItem.label)} />
      ) : (
        "  无"
      );
    },
    [PriorityList]
  );
  const descriptionNode = useCallback((r: AdvanceRecordModel) => {
    let descriptionTxt = "";
    switch (r.action) {
      case ACTION_TYPE.UPDATE_PROCESS_STATUS: // "状态"
      case ACTION_TYPE.UPDATE_TASK_STATUS: // "状态"
      case ACTION_TYPE.FINISH_TASK:
        descriptionTxt = r.comment ? `情况说明：${htmlUnescape(mattchUrl(r.comment))}` : "";
        break;
      case ACTION_TYPE.UPDATE_CONTENT: // 任务描述
        descriptionTxt = r.newContent ? `任务描述：${r.newContent}` : "";
        break;
      case ACTION_TYPE.UPDATE_TITLE: // 任务名称
        descriptionTxt = r.newContent ? `任务名称：${r.newContent}` : "";
        break;
      case ACTION_TYPE.UPDATE_TIME: // 任务时间
        descriptionTxt = r.newContent ? `起止时间：${r.newContent}` : "";
        break;
      default:
    }
    let filesNode = null;
    if (r.attachments) {
      filesNode = (
        // <div className="task-custom-upload-list">
        //   {r.attachments.map((item: any, index: number) => {
        //     return (
        //       <div
        //         className="file-item of-detail-page non-background"
        //         key={item.bizId || item.resourceId || item.fileId}
        //         onClick={() => previewFile(item)}
        //       >
        //         <CalendarIcon
        //           className="left"
        //           width="auto"
        //           src={changeEgovUrl(getAttachmentIcon(item))}
        //         />
        //         <span className="name ellipsis">{item.fileName || item.name}</span>
        //       </div>
        //     );
        //   })}
        // </div>
        <div className="advance-record-msg-file">
          <AttachmentComp
            businessForm={BusinessForm.TASK}
            disabled={true}
            mode="detail"
            // onRemove={onAttachmentRemove}
            fileList={r.attachments || []}
            openPreviewWps={openPreviewWps}
            uploadControlName="task-advance-upload-panel"
            bizId={taskId}
          />
        </div>
      );
    }
    return (
      <>
        {descriptionTxt}
        {filesNode}
      </>
    );
  }, []);

  const SetTitle = useCallback(
    // eslint-disable-next-line complexity
    (r: AdvanceRecordModel) => {
      switch (r.action) {
        case ACTION_TYPE.UPDATE_PROCESS_STATUS: // "推进状态"
          /* if (r.newContent !== r.oldContent) {
                        return (
                            <div>
                                {r.operator} 将 {r.item} 改为 {r.newContent}
                                <br />
                                当前其个人推进进度为
                                {number2percentum(Number(r.userProgress || 0) / 100)}
                            </div>
                        );
                    } else {
                        return (
                            <div>
                                {r.operator} 将 个人推进进度 改为
                                {number2percentum(Number(r.userProgress || 0) / 100)} <br />
                                当前其{r.item}为 {r.newContent}
                            </div>
                        );
                    } */
          return (
            <div>
              {`${r.operator}：推进状态为${
                r.newContent ?? r.oldContent
              },当前个人的推进进度为${number2percentum(Number(r.userProgress || 0) / 100)}`}
            </div>
          );
        case ACTION_TYPE.UPDATE_TASK_STATUS: // "任务状态"
          return (
            <div>
              {r.operator} 将 {r.item} 改为 {r.newContent}
            </div>
          );
        case ACTION_TYPE.UPDATE_OWNER: // 负责人
          return (
            <div>
              {r.operator} 将 {r.item} 改为 {r.newContent}
            </div>
          );
        case ACTION_TYPE.UPDATE_EXECUTOR: // 协同人
          return !r.oldContent && r.newContent ? (
            <div>
              {r.operator} 将 {r.newContent} 添加为 {r.item}
            </div>
          ) : (
            <div>
              {r.operator} 将 {r.oldContent} 从 {r.item} 中移除
            </div>
          );
        case ACTION_TYPE.UPDATE_SUBSCRIBE: // 关注人
          return !r.oldContent && r.newContent ? (
            <div>
              {r.operator} 将 {r.newContent} 添加为 {r.item}
            </div>
          ) : (
            <div>
              {r.operator} 将 {r.oldContent} 从 {r.item} 中移除
            </div>
          );
        case ACTION_TYPE.UPDATE_PRIORITY_TYPE: // 任务类型
          return (
            <div>
              {r.operator} 将 {r.item} 调整为 {changePriorityType(r.newContent)}
            </div>
          );
        case ACTION_TYPE.UPDATE_CONTENT: // 任务描述
          return !r.oldContent && r.newContent ? (
            <div>{r.operator} 新增了任务描述</div>
          ) : (
            <div>{r.operator} 更改了任务描述</div>
          );
        case ACTION_TYPE.UPDATE_RESOURCE: // 附件
          return !r.oldContent && r.newContent ? (
            <div>
              {r.operator} 新增了任务附件{r.newContent}
            </div>
          ) : (
            <div>
              {r.operator} 删除了任务附件{r.oldContent}
            </div>
          );
        case ACTION_TYPE.UPDATE_TITLE: // 任务名称
          return <div>{r.operator} 更改了任务名称</div>;
        case ACTION_TYPE.UPDATE_TIME: // 任务时间
          return <div>{r.operator} 更改了任务时间</div>;
        case ACTION_TYPE.CREATE_TASK: // 创建任务
          return <div>{r.operator} 创建了任务</div>;

        case ACTION_TYPE.RESUME_TASK: // 重新启动任务
          return (
            <div>
              {r.operator} {r.item} 了任务
            </div>
          );
        case ACTION_TYPE.FINISH_TASK: // 整体完成任务
          return (
            <div>
              {r.operator} 将任务标记为 {r.item}
            </div>
          );
        case ACTION_TYPE.CREATE_SUPERVISE: // 我 对 谁 发起了 催办
          return (
            <div>
              {r.operator} 对 {r.newContent} 发起了 {r.item}
            </div>
          );
        case ACTION_TYPE.UPDATE_EXECUTOR_WEIGHT: // 权重更改
          const persons = (r.newContent || r.oldContent || "").split(","); // eslint-disable-line
          return persons.length > 1 || persons[0] ? (
            <div>
              {r.operator}：修改了
              {persons.length < 3
                ? persons.toString()
                : persons.slice(0, 2).toString() + "等" + persons.length + "人"}
              的权重
            </div>
          ) : null;
        case ACTION_TYPE.ARCHIVE_TASK: // 谁 归档了任务
          return <div>{r.operator} 归档了任务</div>;
        case ACTION_TYPE.CANCEL_ARCHIVE_TASK: // 谁 取消了 归档
          return <div>{r.operator} 取消任务归档</div>;
      }
    },
    [RecordsData]
  );
  const openPreviewWps = useCallback(async (item: any) => {
    const opt = {
      fileUrl: item.fileUrl || item.url,
      taskId: taskId || taskId,
      userId: (owner as any).creatorUserId || owner?.userId,
      teamId: owner?.teamId || "",
      fileId: item.fileId
    };
    const [result, err] = await getworkWpsPreViewCode(opt);
    if (err || !result) {
      message.error(err || "该文件暂不支持预览");
      return false;
    }
    openJoyspacePreview({
      code: result.code,
      host: joyspaceHost,
      isShowHeader: 1,
      canSaveToJoyspace: 1,
      canDownload: 1
    });
  }, []);
  function downloadFile(item: any) {
    if (item.status === FileStatus.Uploading) {
      return;
    }
    console.log("任务进度列表", item);
    item.fileUrl = item.fileUrl || item.url;
    item.fileName = item.fileName || item.name;

    if (item.fileType?.startsWith("joyspace")) {
      let fileUrl = item.fileUrl;
      try {
        const { joyspaceHost } = appRuntimeEnv;
        const path = buildPagePathKey(Number(item.fileType.split("/")[1])).subPath;
        analysisLog(
          "xtbg_jzb_joysapce_inOtherModule_1676971574856",
          "3",
          path,
          item.fileId || item.bizId
        );
        fileUrl = `${joyspaceHost}/${path}/${item.fileId || item.bizId}`;
      } catch (error) {
        console.error(error);
      }
      return DeeplinkEvent.open(changeEgovUrl(fileUrl));
    }
    if (canJoyspacePreview(item?.fileName || item?.name || "")) {
      openPreviewWps(item);
      return;
    }
    if (isFocusEnv()) {
      FocusSDK.downloadFile(changeEgovUrl(item.fileUrl), {
        saveAs: true,
        filename: item.fileName,
        onStarted: () => {},
        onProgress: async (progress: any, downloadItem?: DownloadItem) => {
          if (progress?.status === "interrupted") {
            downloadItem?.cancel();
            const fileXhr = await getDownloadFileRes(changeEgovUrl(item.fileUrl || item.url));
            if (fileXhr?.response?.indexOf(ErrorCode.FILE_EXPIRED) > -1) {
              return message.error(t("file is expired"));
            }
            if (fileXhr?.response?.indexOf(ErrorCode.FILE_CHECK_PROCESS_ERROR) > -1) {
              return message.error(t("file is scanning"));
            }
            if (fileXhr?.response?.indexOf(ErrorCode.FILE_CHECK_FAIL_ERROR) > -1) {
              return message.error(t("file is not safe"));
            }
            return message.error(t("download error"));
          }
        },
        onCancel: () => {
          // console.log('onCancel ==>取消下载');
        },
        onPause: () => {
          // console.log('onPause ==> 暂停下载');
        },
        onResume: () => {
          // console.log('onResume ==> 恢复下载');
        },
        onFinish: (file: { path: string; filename: string }) => {
          return message.success(t("download success"));
        },
        onError: (error: any) => {
          FocusSDK.printLog("download file==>>", error);
          const errMsg = JSON.parse(error?.error || "{}");
          return message.error(errMsg?.message?.toString() || t("download error"));
        }
      });
    } else {
      // web 端下载文件
      const name = item.fileName;
      const url = getFileUrl(item.fileUrl);
      downLoadFile(name, url);
    }
  }

  function getAttachmentIcon(item: any) {
    const { fileType, fileName } = item;
    if (fileType?.startsWith("joyspace")) {
      try {
        const strs = fileType.split("/");
        if (strs[1] === "6") {
          if (!isNaN(Number(strs[2]))) {
            let ext = fileName.split(".").pop();
            switch (ext) {
              case "doc":
                return getFileIconByMime("application/msword")[0];
              case "xls":
                return getFileIconByMime("application/vnd.ms-excel")[0];
              default:
                break;
            }
          }
          return getFileIconByMime(strs.slice(2).join("/") || "application/octet-stream")[0];
        } else {
          return buildJoyspaceIconUrl({
            title: fileName,
            pageType: strs[1],
            type: strs.slice(2).join("/") || "",
            apiHost: joyspaceApiHost
          });
        }
      } catch (error) {
        return getFileIconByMime(fileType || "application/octet-stream")[0];
      }
    }
    return getFileIconByMime(fileType || "application/octet-stream")[0];
  }

  if (loading) {
    return <Loading />;
  }

  const recordsArr = UniqBy(RecordsData, "recordId");
  // 处理 数据无totalProgress的情况
  recordsArr.reduceRight((tmp: number | string, v) => {
    v.totalProgress = v.totalProgress ?? tmp;
    return v.totalProgress;
  }, 0);

  return (
    <div className={"advance-record " + (className || "")} style={{ flex: 1, overflow: "auto" }}>
      {/* <ScrollView ref={scrollRef} autoHide style={{ position: "" }}> */}
      {RecordsData.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("no data")} />
      ) : (
        <>
          {ProcessAuditList.map((item: taskProcessAuditList) => {
            return (
              <div className="advance-record-msg-box" key={item.auditId}>
                <div className="advance-record-msg-con">
                  <div className="advance-record-msg-title">
                    <i className="advance-record-msg-t">【待审批】</i>
                    {item.excutorName}: 推进状态为
                    {PROCESS_STATUS_EXECUTORS[item.afterProcessStatus as PROCESS_STATUS]},
                    当前个人的推进进度为{number2percentum(Number(item.afterProgress || 0) / 100)}
                    {userData?.userId === item.ownerUserId && (
                      <div className="advance-record-msg-btn">
                        <span
                          className="btn-no"
                          onClick={() => {
                            setIsModalOpen(true);
                            setAuditItem(item);
                          }}
                        >
                          驳回
                        </span>
                        <span
                          className="btn-yes"
                          onClick={() => {
                            hanleOk(item);
                          }}
                        >
                          同意
                        </span>
                      </div>
                    )}
                  </div>
                  {item.processComment && (
                    <div className="advance-record-msg-illustrate">
                      情况说明：{item.processComment}
                    </div>
                  )}
                </div>
                <div className="advance-record-msg-file">
                  <AttachmentComp
                    businessForm={BusinessForm.TASK}
                    disabled={true}
                    mode="detail"
                    // onRemove={onAttachmentRemove}
                    fileList={item.processAttachments || []}
                    openPreviewWps={openPreviewWps}
                    uploadControlName="task-advance-upload-panel"
                    bizId={taskId}
                  />
                </div>
              </div>
            );
          })}
          <Steps
            className="lb-decorate"
            progressDot={(dot: any, { index }: any) => (
              <>
                <b className="lt-whole-progress">
                  {!recordsArr[index].totalProgress
                    ? "0%"
                    : number2percentum(Number(recordsArr[index].totalProgress) / 100)}
                </b>
                {dot}
              </>
            )}
            direction="vertical"
            status="wait"
            current={1}
          >
            {recordsArr.map((item: AdvanceRecordModel) => {
              return (
                <Step
                  key={item.recordId}
                  title={<div className="user-select-text">{SetTitle(item)}</div>}
                  subTitle={productBriefTimeStr(item.time)}
                  description={<div className="user-select-text">{descriptionNode(item)}</div>}
                />
              );
            })}
          </Steps>
          <div className="more">
            {count * 20 < total && (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setCount(count + 1);
                }}
              >
                加载更多
              </span>
            )}
          </div>
        </>
      )}
      {/* </ScrollView> */}
      {isModalOpen && (
        <Modal
          width={360}
          className="RejectModal"
          title="驳回意见"
          visible={isModalOpen}
          destroyOnClose={true}
          onOk={onReject}
          centered={true}
          okText="确定"
          cancelText="取消"
          okButtonProps={{ disabled: RejectValue ? false : true }}
          onCancel={() => {
            setIsModalOpen(false);
          }}
        >
          <Input.TextArea
            placeholder="请输入驳回意见"
            onChange={RejectChange}
            autoSize={{ minRows: 4, maxRows: 4 }}
          />
        </Modal>
      )}
    </div>
  );
}
function mapStateToProps({ work, user }: any) {
  const { detailState } = work;
  return {
    taskId: detailState.taskId,
    userData: user.userData.user
  };
}

function mapDispatchToProps(_dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(AdvanceCom);
